export default function (timeout) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), timeout);
  });
}
